import { SubGroup, DaysFilter } from '../../services/insights/types';
import { getTimeOfCheckIns } from '../../services/insights/time';
import {
  getWordCloud,
  getWordsCategorized
} from '../../services/insights/words';
import { getAvgDailyEnergyData } from '../../services/insights/calcullations';

const getSummaryData = (data: SubGroup) => {
  const checkins = data?.checkins?.length || 0;
  const reflections = data?.reflections?.length || 0;
  const mindfulnesses = data?.mindfulnesses?.length || 0;

  return {
    name: data.name,
    checkins,
    reflections,
    mindfulnesses,
    actionsCompleted: checkins + reflections + mindfulnesses
  };
};

const getMonthGraphs = (
  data: SubGroup,
  filter: DaysFilter,
  _isGroup: boolean
) => ({
  summary: getSummaryData(data),
  avgDailyEnergy: getAvgDailyEnergyData(data.checkins || [], filter.days),
  timeOfCheckIns: getTimeOfCheckIns(data.checkins || []),
  wordCloud: getWordCloud(data.checkins || []),
  wordsCategorized: getWordsCategorized(data.checkins || [])
});

export { getMonthGraphs, getSummaryData, getWordCloud };
